$(function() {

    $("#resendActivationEmail").click(function(e){
        e.preventDefault();
        var id = $(this).attr('data-id');

        $.ajax({
            type: "POST",
            url: $("body").data("base-url") + "users/resendActivationEmail",
            data: {userId: id},
            success: function (responseText) {
               var data = JSON.parse(responseText);

               if(data.status === 'success') {
                   Materialize.toast('New password email has been sent!', 2000);
               }
            }
        });
    });

    if ($('.wysiwyg').length) {
        $('.wysiwyg .textarea').each(function () {
            var $this = $(this);
            var limit = $this.parent().children().find('textarea').attr('maxlength');
            var id = "#" + $this.attr('id');

            var toolbarOptions = {
              handlers: {
                // handlers object will be merged with default handlers object
                'link': function(value) {
                  if (value) {
                    var href = prompt('Enter the URL');
                    this.quill.format('link', href);
                  } else {
                    this.quill.format('link', false);
                  }
                }
              }
            };
            
            var options = {
                theme: 'snow',
                modules: {
                    toolbar: toolbarOptions
                }
            };

            var quill = new Quill(id, options);
            quill.container.firstChild.innerHTML = $this.parent().find('textarea').val();
            quill.on('text-change', function(eventName) {
                var text = quill.container.firstChild.innerHTML;
                if (limit && quill.getLength() > limit) {
                    quill.deleteText(limit, quill.getLength());
                    text = quill.container.firstChild.innerHTML;
                    $this.parent().find('textarea').val(text);
                } else {
                    $this.parent().find('textarea').val(text);
                    //$this.parent().find('#zoning_character_count').text(400 - text.length);
                }
            });
        });

        $('.wysiwyg .textarea').parent().find('.ql-toolbar').each(function () {
            var $this = $(this);
            $this.find('.ql-formats').first().remove();
            $('.ql-container').css('height', '15%');
        });
    }




    // Sidebar sticky scrolling
    if ($('.approach-sidebar').length) {

        calcSidebar();

        $(window).on('scroll', function() {
            calcSidebar();
        });
    }

    // Overview vertical nav sticky scrolling
    if ($('.overview-vertical-nav').length) {

        calcOverviewNav();

        $(window).on('scroll', function() {
            calcOverviewNav();
        });
    }

    // Scroll Up
    if ($('#scrollup').length) {

        // Click event
        $(document).on('click', '#scrollup', function() {
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return false;
        });

        // Initial scroll position
        var scroll = $(this).scrollTop();
        calcScrollUp(window);

        $(window).on('scroll', function(e) {
            calcScrollUp(this);
        });
    }


    convertImgToSvg();
});

function convertImgToSvg() {
    jQuery('img.svg').each(function(){
        var $img = jQuery(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');

        jQuery.get(imgURL, function(data) {
            // Get the SVG tag, ignore the rest
            var $svg = jQuery(data).find('svg');

            // Add replaced image's ID to the new SVG
            if(typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if(typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass+' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');

            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
            if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
            }

            // Replace image with new SVG
            $img.replaceWith($svg);

        }, 'xml');

    });
}

function calcScrollUp($this) {

    scroll = $($this).scrollTop();

    if (scroll > 1000) {
        $('#scrollup').addClass('in');
    } else {
        if ($('#scrollup').hasClass('in')) {
            $('#scrollup').fadeOut('fast', function() {
                $(this).removeClass('in').removeAttr('style');
            });
        }
    }
}

function calcSidebar() {

    var activate = jQuery('header .header_wrap').outerHeight();

    var offset = jQuery(this).scrollTop();
    if (offset > activate) {
        jQuery('.approach-sidebar').css({
            'position': 'fixed',
            'margin-top': 0
        });
    } else {
        jQuery('.approach-sidebar').css({
            'position': 'absolute',
            'margin-top': activate + "px"
        });
    }
}

function calcOverviewNav() {

    var activate = jQuery('.col.s2').offset().top;

    var offset = jQuery(this).scrollTop();
    if (offset > activate) {
        jQuery('.overview-vertical-nav').css({
            'position': 'fixed',
            'top': '0'
        });
    } else {
        jQuery('.overview-vertical-nav').css({
            'position': 'absolute',
            'top': '222px'
        });
    }
}